﻿module.exports = {
    Version_versionNumber_: 'Versie {{ versionNumber }}',
    DataReadOn_lastSuccessfulDatabase_: 'Data vernieuwd op {{ lastSuccessfulDatabase | date: \'dd-MM HH:mm\' }}'
};
